import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "section"];

  scrollToSection() {
    this.sectionTarget.scrollIntoView({
      behavior: "smooth",
    });
    this.buttonTarget.blur();
  }
}
